import React from 'react';
import { Select } from '../../Form';
import Label from './Label/Label';
import { countries as allCountries } from '../../../lib/countries';

export default function CountryField({ field, onChange, onBlur }) {
  const { label, limitAllowedCountries } = field;

  let countries;
  if (limitAllowedCountries?.enabled && limitAllowedCountries.countries?.length > 0) {
    countries = allCountries.filter(country =>
      limitAllowedCountries.countries?.includes(country.alpha2),
    );
  } else {
    countries = allCountries;
  }

  return (
    <>
      {label && (
        <Label htmlFor={field._id} className="cp_form-label" required={field.required}>
          {label}
        </Label>
      )}

      <Select
        onChange={e => {
          onChange(e.target.value);
        }}
        key={field._id}
        required={field.required}
        value={field.value}
        defaultValue=""
        className="cp_form-select"
        onBlur={onBlur}
      >
        <option value="" disabled={field.required} className="cp_form-option">
          {field.placeholder || 'Select an option'}
        </option>

        {countries?.map(country => (
          <option
            value={country.alpha2}
            key={country.alpha2}
            className={`cp_form-option flex justify-between`}
          >
            {country.name}
          </option>
        ))}
      </Select>
    </>
  );
}
